export default __webpack_public_path__ + "34d444445d70096ebc55f63696110e84.png";